import React, { useRef, useState } from 'react';
import { useLabels } from 'src/StoreDataProvider';
import { InputSearchProps } from './inputSearch.types';

const InputSearch: (props: InputSearchProps) => JSX.Element = ({
  id,
  label,
  value,
  onChange,
  onBlur,
  onSearch,
  onClear,
}) => {
  const labels = useLabels();
  const inputRef = useRef<HTMLInputElement>(null);
  const [isXActive, setIsXActive] = useState(false);

  return (
    <div className="input-search">
      <label
        id={`input-search__label-${id}`}
        htmlFor={`input-search__input-${id}`}
        className="input-search__label"
      >
        {label}
      </label>
      <div className="input-search__wrapper">
        <input
          id={`input-search__input-${id}`}
          data-cy="input-field-search"
          type="text"
          aria-labelledby={`input-search__label-${id}`}
          placeholder={labels.enterSearchTerm}
          onChange={e => {
            onChange(e.target.value);
          }}
          onKeyDown={e => {
            if (e.key === 'Enter' && inputRef.current) onBlur?.();
          }}
          value={value}
          ref={inputRef}
          onBlur={() => {
            if (!isXActive) {
              onBlur?.();
            }
            setIsXActive(false);
          }}
          aria-label={labels.eraseSearchTerm}
        />
        <div className="input-search__icons">
          {value?.length ? (
            <button
              id="clear-search"
              onMouseDown={() => {
                setIsXActive(true);
                onClear?.();
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  setIsXActive(true);
                  onClear?.();
                }
              }}
              onClick={() => {
                setIsXActive(false);
              }}
              aria-label={labels.eraseSearchTerm}
            >
              <em className="icon-schliessen" />
            </button>
          ) : null}
          <button
            id="start-search"
            onClick={() => {
              onSearch?.();
            }}
            aria-label={labels.startSearch}
          >
            <em className="icon-lupe" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default InputSearch;
